/**
 * Public product name per Vite build `mode`. It MUST match, character for character,
 * the app name on each environment's Google OAuth consent screen — Google's brand
 * verification rejects the app when the homepage shows a different name.
 *
 * Kept free of `import.meta` / DOM access so `vite.config.ts` (Node) can import it to
 * stamp the same name into `index.html`; app code reads `APP_NAME` from `env.ts`.
 * Any mode not listed (local `development`, `develop`, `e2e`, `analyze`) is dev.
 */
const APP_NAMES: Record<string, string> = {
  production: 'Lily MAX',
  staging: 'Lily MAX Stage',
};

const DEV_APP_NAME = 'Lily MAX Dev';

/** Resolves the product name for a Vite build mode (see `APP_NAMES`). */
export function appNameForMode(mode: string): string {
  return APP_NAMES[mode] ?? DEV_APP_NAME;
}
